import React, { useState, useEffect } from "react";
import Popup from "react-animated-popup";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";

import { cvdcalculation as cvdcalc } from "../../assets/data/cvdcalculation";

const CVDCalculator = (props) => {
  const history = useHistory();
  const customfieldobj = props.customfieldobj;
  const [visible, setVisible] = useState(true);
  const [cvdRiskValue, setCvdRiskValue] = useState(0);
  const [symptomRedirect, setSymptomRedirect] = useState(false); 
  const [symptomsList, setSymptomsList] = useState([])


  useEffect(() => {
    if (props.openFrom == "historyStage") {
      checkSymptoms()}

    // console.log("CVDCalculator",props.symptomRedirect)
    const cdvRisk = calculateCDVRisk2();
    if (cdvRisk) {
      setCvdRiskValue(cdvRisk);
    }
  }, []);

  useEffect(() => {
    if (visible) {
      setTimeout(function () {
        const popupDiv = document.querySelector(".animated-popup");
        const parentDiv = popupDiv && popupDiv.parentNode;
        if (popupDiv) {
          parentDiv.style.backgroundColor = "rgba(0,0,0,0.4)";
        }
      }, 100);
    }
  }, [visible]);

  function calculateCDVRisk() {
    // Coefficients for the Framingham Risk Score calculation (hypothetical values)
    const coefficients = {
      age: 3.06117,
      male: 1.47582,
      female: 0.6585,
      smoking: 0.877,
      diabetes: 0.921,
      systolicBloodPressure: 1.93303,
      totalCholesterol: 0.962,
      hdlCholesterol: -0.657,
      intercept: -29.4,
    };

    // Get the gender coefficient
    const genderCoefficient =
      props.gender === "male" ? coefficients.male : coefficients.female;

    // Calculate log odds for each risk factor
    const logAge = coefficients.age * Math.log(props.age);
    const logGender = genderCoefficient * Math.log(genderCoefficient);
    const logSmoking = coefficients.smoking * props.smoking;
    const logDiabetes = coefficients.diabetes * props.diabetes;
    const logSystolicBP =
      coefficients.systolicBloodPressure *
      Math.log(props.systolicBloodPressure);
    const logTotalCholesterol =
      coefficients.totalCholesterol * Math.log(props.totalCholesterol);
    const logHDLCholesterol =
      coefficients.hdlCholesterol * Math.log(props.hdlCholesterol);

    // Calculate the log odds sum
    const logOddsSum =
      logAge +
      logGender +
      logSmoking +
      logDiabetes +
      logSystolicBP +
      logTotalCholesterol +
      logHDLCholesterol +
      coefficients.intercept;

    // Calculate the 10-year CVD risk using the Framingham Risk Score equation
    const tenYearRisk = 1 - Math.pow(0.88936, Math.exp(logOddsSum));

    // Convert the risk to percentage
    const riskPercentage = tenYearRisk * 100;

    return riskPercentage;
  }

  function calculateCDVRisk2() {
    const ageRisk = props.age * 0.05;
    const sbpRisk = props.systolicBloodPressure * 0.1;
    const cholesterolRisk = props.totalCholesterol * 0.01;
    const hdlcholesterolRisk = props.hdlCholesterol * 0.01;
    const smokingRisk = props.smoking || props.smoking == 1 ? 1 * 0.877 : 0;
    const diabetesRisk = props.diabetes || props.diabetes == 1 ? 1 * 0.921 : 0;

    const cvdRisk =
      ageRisk +
      sbpRisk +
      cholesterolRisk +
      hdlcholesterolRisk +
      smokingRisk +
      diabetesRisk;

    let smoker = props.smoking && props.smoking == 1 ? "smoker" : "non-smoker";
    let agecategory,
      bmicategory,
      sysBP = "";
    let cvd = 0;

    if (props.age) {
      if (40 <= Number(props.age) && Number(props.age) <= 44) {
        agecategory = "40-44";
      } else if (45 <= Number(props.age) && Number(props.age) <= 49) {
        agecategory = "45-49";
      } else if (50 <= Number(props.age) && Number(props.age) <= 54) {
        agecategory = "50-54";
      } else if (55 <= Number(props.age) && Number(props.age) <= 59) {
        agecategory = "55-59";
      } else if (60 <= Number(props.age) && Number(props.age) <= 64) {
        agecategory = "60-64";
      } else if (65 <= Number(props.age) && Number(props.age) <= 69) {
        agecategory = "65-69";
      } else if (70 <= Number(props.age) && Number(props.age) <= 74) {
        agecategory = "70-74";
      }
    }

    if (props.bmi) {
      if (20 > Number(props.bmi)) {
        bmicategory = "19";
      } else if (20 <= Number(props.bmi) && Number(props.bmi) <= 24) {
        bmicategory = "20-24";
      } else if (25 <= Number(props.bmi) && Number(props.bmi) <= 29) {
        bmicategory = "25-29";
      } else if (30 <= Number(props.bmi) && Number(props.bmi) <= 34) {
        bmicategory = "30-34";
      } else if (35 <= Number(props.bmi)) {
        bmicategory = "35";
      }
    }

    if (props.systolicBloodPressure) {
      if (180 <= Number(props.systolicBloodPressure)) {
        sysBP = "180";
      } else if (
        160 <= Number(props.systolicBloodPressure) &&
        Number(props.systolicBloodPressure) <= 179
      ) {
        sysBP = "160-179";
      } else if (
        140 <= Number(props.systolicBloodPressure) &&
        Number(props.systolicBloodPressure) <= 159
      ) {
        sysBP = "140-159";
      } else if (
        120 <= Number(props.systolicBloodPressure) &&
        Number(props.systolicBloodPressure) <= 139
      ) {
        sysBP = "120-139";
      } else if (120 > Number(props.systolicBloodPressure)) {
        sysBP = "119";
      }
    }

    if (props.gender && smoker && agecategory && sysBP && bmicategory)
      cvd = cvdcalc[props.gender][smoker][agecategory][sysBP][bmicategory];

    return cvd;
  }

  const hidePopup = () => {
    props.setopenCVDRisk(false);
    setVisible(false);
  };

  function checkSymptoms(){
    symptomsList.push(
      customfieldobj.ChangebowelhabitsID, 
      customfieldobj.UnexplainedweightlossID,
      customfieldobj.AnaemiaID,
      customfieldobj.BloodinthestoolID,
      customfieldobj.WhitelesionsleukoplakiaID,
      customfieldobj.RedlesionsleukoplakiaID,
      customfieldobj.GrowthulcerationID,
      customfieldobj.NosebleedID,
      customfieldobj.PermanentblockednoseID,
      customfieldobj.DeafnessID,
      customfieldobj.NodesinupperID,
      customfieldobj.PersistenthoarsenessvoiceID,
      customfieldobj.UpperabdominalpainID,
      customfieldobj.RecentonsetindigestionID,
      customfieldobj.UnexplainedweightlossID,
      customfieldobj.WeightlossID,
      customfieldobj.Weightlossinthelast3monthsID,
      customfieldobj.BrownlesionID,
      customfieldobj.AreasofpatchyID,
      customfieldobj.LesionsoreskinID,
      customfieldobj.PassingbloodinurineID,
      customfieldobj.DifficultyurinationID,
      customfieldobj.FrequentnocturnalurinationID,
      customfieldobj.SwellingofonetesticleID,
      customfieldobj.Feverforover7daysID,
      customfieldobj.progressiveheadacheID,
      customfieldobj.NocturnalheadachevomitingID,
      customfieldobj.LossofappetiteID,
      customfieldobj.Fatiguelast3monthsID,
      customfieldobj.SignificantnightsweatsID,
      customfieldobj.PetechiaePEID,
      customfieldobj.BruisesID,
      customfieldobj.BleedingID,
      customfieldobj.PalmarconjunctivalpallorID,
      customfieldobj.AbnormalityeyesID,
      customfieldobj.NodesPEID,
      customfieldobj.SignsandfocalID,
      customfieldobj.AbdominalpalpablemassID,
      customfieldobj.HepatomegalyPEID,
      customfieldobj.SplenomegalyID,
      customfieldobj.MassregionbodyID,
      customfieldobj.NodesID
      )
      let formformat = props.activeCaseFormData.data.formFormat;
      let checkedList = []

      let checkedSymptoms = formformat[customfieldobj.symptomsDataElementGroup];
      let checkedSigns = formformat[customfieldobj.SignsID];
      let checkedAbnormality = formformat[customfieldobj.AbnormalityeyesDEGroupID];
      let checkedSignsandfocal = formformat[customfieldobj.SignsandfocalDEGroupID];

      // Pushing all the symptoms which will redirect to Inital stage in one array
      if(checkedSymptoms && checkedSymptoms.length > 0)
      {
        for(let i=0; i< checkedSymptoms.length; i++ )
        {
          checkedList.push(checkedSymptoms[i])
        }
      }
      if(checkedSigns && checkedSigns.length > 0)
      {
        for(let i=0; i< checkedSigns.length; i++ )
        {
          checkedList.push(checkedSigns[i])
        }
      }
      if(checkedAbnormality && checkedAbnormality.length > 0)
      {
        for(let i=0; i< checkedAbnormality.length; i++ )
        {
          checkedList.push(checkedAbnormality[i])
        }
      }
      if(checkedSignsandfocal && checkedSignsandfocal.length > 0)
      {
        for(let i=0; i< checkedSignsandfocal.length; i++ )
        {
          checkedList.push(checkedSignsandfocal[i])
        }
      }

      // Checking if amongst the checked symptoms is one from the above list so as to redirect it to Initial visit stage 
      for (let i = 0; i < symptomsList.length; i++) {
        // If current element of array1 is found in array2, return true
        // console.log("checkedList",checkedList,symptomsList)
        if (checkedList.includes(symptomsList[i]) || (checkedAbnormality && checkedAbnormality.length > 0)) {
            setSymptomRedirect(true)
        }
    }
    // If no common elements are found, return false
    return false;
  }

  const conditionalRedirect = () => {

    if (props.openFrom == "historyStage") {
    // console.log("symptomsList",props.symptomRedirect)

      // if(symptomRedirect)
      // {
        // console.log("symptomRedirect",symptomRedirect)
        props.setValue(props.initialassessmentindex);
        props.setopenCVDRisk(false);
        setVisible(false);
      //}
      // else if (cvdRiskValue && cvdRiskValue.value >= 20) {
      //   props.setValue(props.initialassessmentindex);
      //   props.setopenCVDRisk(false);
      //   setVisible(false);
      // } 
      //else {
       // history.push("/layout/home");
      
      //}
    } else {
      props.setopenCVDRisk(false);
      setVisible(false);
    }
  };

  return (
    <div className="custom-popup">
      <Popup
        className={
          window.cordova ? "animated-popup" : "animated-popup popup-width"
        }
        id="animated-popup"
        visible={visible}
        onClose={() => hidePopup()}
      >
        {/* <div className="bmibg"></div> */}
        <h1 align="center" className="popupbmi-title mT5 mTB">
          {props.name}'s CVD Risk
        </h1>
        {cvdRiskValue && cvdRiskValue.value > 0 ? (
          <h1 className={"mT5 mTB " + cvdRiskValue.color}>
            <p align="center" className="popupbmi-result">
              {cvdRiskValue.value ? cvdRiskValue.value + "%" : "0%"}
            </p>
          </h1>
        ) : (
          ""
        )}
        {cvdRiskValue && cvdRiskValue.value > 0 ? (
          <h1 align="center" className={"popupbmi-title mT5 mTB"}>
            {props.openFrom == "historyStage" &&
              (cvdRiskValue && cvdRiskValue.value >= 20 || symptomRedirect
                ? "This patient requires further assessment so refer the patient for Initial visit/Assessment"
                : "This patient is fine and need not be referred for further assessment")}
          </h1>
        ) : (
          <h1 align="center" className={"popupbmi-title mT5 mTB"}>
            {
              "The patient's data is not in the range to calculate CVD"
            }
          </h1>
        )}

        <p align="center" className="mT0 mB0">
          <Button
            className="popup-btn"
            align="center"
            variant="contained"
            color="success"
            onClick={() => conditionalRedirect()}
          >
            OK
          </Button>
        </p>
      </Popup>
    </div>
  );
};

export default CVDCalculator;
